import { useEffect, useMemo } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { OPTIONAL_EXTRA_PRODUCT_TYPE_ID } from 'utils/constant';
import { price } from 'utils/helpers';
import StepperField from 'components/formik/stepper_field/stepper_field';

const OptionalExtras = ({ resource }) => {
  const { setFieldValue } = useFormikContext();
  const group = useMemo(() => {
    const resourceGroups = resource.resource_groups || [];

    return resourceGroups.find(
      (item) => item.product_type_id === OPTIONAL_EXTRA_PRODUCT_TYPE_ID
    );
  }, [resource]);
  const hasOptionalExtras = Boolean(group?.package_items?.length);

  useEffect(() => {
    if (hasOptionalExtras) {
      setFieldValue('optionalExtraGroupId', group.id);
    }
  }, [setFieldValue, group, hasOptionalExtras]);

  if (!hasOptionalExtras) {
    return null;
  }

  return (
    <div className="border-top py-4">
      <h4 className="mb-4">Optional Extras</h4>
      {group.package_items.map(({ id, resource: resourceItem }) => {
        const name = `optionalExtras.${id}`;

        return (
          <div key={name} className="item-selection">
            <div className="d-flex justify-content-between align-items-center">
              <div className="item-selection__title">
                <div className="d-flex align-items-center">
                  <label htmlFor={name}>
                    <strong>{resourceItem.name}</strong>
                  </label>
                </div>
                <p className="mt-2">
                  {price(resourceItem.todays_price_in_cents)}
                </p>
              </div>
              <div className="item-selection__stepper">
                <Field component={StepperField} name={name} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

OptionalExtras.propTypes = {
  resource: PropTypes.shape({
    resource_groups: PropTypes.arrayOf(
      PropTypes.shape({
        product_type_id: PropTypes.number,
        package_items: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            resource: PropTypes.shape({
              name: PropTypes.string,
              todays_price_in_cents: PropTypes.number,
            }),
          })
        ),
      })
    ),
  }),
};

export default OptionalExtras;
